/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { useState } from 'react';
import styles from '../../../styles/components/pageComponents/dashboard/DashboardPrograms.module.css';

import enrollIcon from '../../../assets/profile/dd2.png';

import { useMemo } from 'react';
import {
	useCourseCatalog,
	useCourseWithModulesAndSessions,
} from '../../../hooks/useCourse';
import { useMentoringHours } from '../../../hooks/useMentoringHours';
import { useCoaching } from '../../../hooks/useCoaching';
import { useLearnerProfilePrograms } from '../../../hooks/useCourse';
import { useNavigate } from 'react-router-dom';
import UpcomingActivityCard from './learner/UpcomingActivityCard';
import ProgramTable from './coach/ProgramTable';
import LearnerTable from './learner/LearnerTable';

import { useGoals } from '../../../hooks/useGoals';
import { useGoalList } from '../../../hooks/useGoalList';
// import Dropdown from '../../../components/controlVariations/DropdownProgram';
import MultiSelectDropdown from '../../../components/controlVariations/Multiselectdropdowntoggle';

interface DashboardProgramsProps {
	learnerId: string;
}

type Tab = 'activity' | 'goals' | 'mentoring';

// const DashboardPrograms = () => {
const DashboardPrograms: React.FC<DashboardProgramsProps> = ({ learnerId }) => {
	const [activeTab, setActiveTab] = useState<Tab>('activity');
	const [selectedProgram, setSelectedProgram] = useState('');
	const [selectedProgramLabel, setSelectedProgramLabel] = useState('');

	
	const goalFilters = useMemo(
		() => ({
			programid: selectedProgram || undefined,
			userid: learnerId,
			istemplate: false,
			page: 1,
			limit: 20,
		}),
		[selectedProgram,learnerId]
	);

	const {
		goals,
		total,
		loading: goalsLoading,
		error: goalsError,
	} = useGoalList(goalFilters);

	const navigate = useNavigate();

	const { programs } = useLearnerProfilePrograms(learnerId);
	const {
		upcomingLessons,
		loading: upcomingLoading,
		error: upcomingError,
	} = useCoaching(learnerId, 2);
	const {
		mentoringHours,
		loading: mentoringLoading,
		error: mentoringError,
	} = useMentoringHours();

	const handleViewProgram = () => {
		if (selectedProgram) {
			navigate(`/dashboard/programs/${selectedProgram}`);
		} else {
			navigate('/dashboard/programs');
		}
	};

	const {
		courses,
		isLoading: catalogLoading,
		error: catalogError,
	} = useCourseCatalog();
	const courseId = courses && courses.length > 0 ? courses[0].id : '';

	const {
		courseData,
		isLoading: detailsLoading,
		error: detailsError,
	} = useCourseWithModulesAndSessions(courseId);

	if (catalogLoading) return <div>Loading catalog...</div>;
	if (catalogError) return <div>{catalogError}</div>;
	if (!courseId) return <div>No course found</div>;
	if (detailsLoading) return <div>Loading course details...</div>;
	if (detailsError) return <div>{detailsError}</div>;

	
	
	const formatDuration = (minutes: number) => {
	const hours = Math.floor(minutes / 60);
	const remainingMinutes = minutes % 60;

	if (hours > 0 && remainingMinutes > 0) {
		return `${hours} hr ${remainingMinutes} min`;
	}

	if (hours > 0) {
		return `${hours} hr`;
	}

	return `${remainingMinutes} min`;
};
	const mentoringData =
	mentoringHours?.lessons?.map((lesson, index) => {
		const durationText = formatDuration(
			lesson.durationminutes ?? 0
		);

		const isCompleted =
			lesson.status?.toLowerCase() === 'completed';

		return {
			id: index + 1,

			programName: lesson.coursetitle,

			hours: isCompleted
				? `${durationText}/${durationText}`
				: `0/${durationText}`,

			progress: isCompleted ? 100 : 0,
		};
	}) || [];
	
	
	const goalsData =
	goals?.map(goal => {
		const current = goal.currentvalue ?? 0;
		const target = goal.targetvalue ?? 0;

		const unitMap: Record<string, string> = {
			Hours: 'hrs',
			Days: 'days',
			Percentage: '%',
			Number: '',   // Don't show anything
		};

		const unit = unitMap[goal.unit] ?? goal.unit ?? '';

		return {
			id: goal.id,
			goal: goal.title,

			progressText: target
				? `${current}/${target}${unit ? ` ${unit}` : ''}`
				: `${current}${unit ? ` ${unit}` : ''}`,

			 progress: goal.progress,
		};
	}) || [];

	const dropdownOptions =
		programs?.map((program: any) => ({
			label: program.title,
			value: program.id,
		})) || [];

		const truncateText = (text: string, maxLength = 20) => {
	if (!text) return '';

	return text.length > maxLength
		? `${text.slice(0, maxLength)}...`
		: text;
};

	return (
		<div>
			<div className={styles.programLable}>Your engagement</div>
			<div className={styles.wrapper}>
				<div className={styles.tabs}>
					<button
						className={`${styles.tab} ${
							activeTab === 'activity' ? styles.active : ''
						}`}
						onClick={() => setActiveTab('activity')}
					>
						<span className={styles.tabLabel}>Activity</span>
					</button>

					<button
						className={`${styles.tab} ${
							activeTab === 'goals' ? styles.active : ''
						}`}
						onClick={() => setActiveTab('goals')}
					>
						<span className={styles.tabLabel}>Goals</span>
					</button>

					<button
						className={`${styles.tab} ${
							activeTab === 'mentoring' ? styles.active : ''
						}`}
						onClick={() => setActiveTab('mentoring')}
					>
						<span className={styles.tabLabel}>Mentoring Hours</span>
					</button>
				</div>

				{/* Content */}
				{activeTab === 'activity' && (
					<div className={styles.content}>
						{upcomingLoading ? (
							<div>Loading activities...</div>
						) : !upcomingLessons?.upcoming ||
						  upcomingLessons.upcoming.length === 0 ? (
							<div className={styles.emptyState}>
								No upcoming activities found.
							</div>
						) : (
							upcomingLessons.upcoming.map(lesson => {
								

								
const startDate = new Date(lesson.scheduledstarttime);
const endDate = new Date(lesson.scheduledendtime);

const formattedDate = startDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});

const startTime = startDate.toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
});

const endTime = endDate.toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
});

const formattedTime = `${startTime} - ${endTime}`;

								return (
									<UpcomingActivityCard
										key={lesson.lessonid}
										icon={enrollIcon}
										programLabel={lesson.programname}
										title={lesson.lessonname}
										subtitle={`Session by ${
											lesson.coach?.fullname || 'Coach'
										}`}
										date={formattedDate}
										time={formattedTime}
										onPrimaryClick={() => {
											if (lesson.meetingurl) {
												window.open(
													lesson.meetingurl,
													'_blank'
												);
											}
										}}
										onSecondaryClick={() => {
											navigate(
												`/dashboard/programs/${lesson.courseid}`
											);
										}}
									/>
								);
							})
						)}
					</div>
				)}
				{activeTab === 'goals' && (
					<div className={styles.content}>
						<div className={styles.dropdownWrapper}>
							<div className={styles.dropdownWrapper2}>
								<span className={styles.dropdownlable}>
									program
								</span>
								{/* <Dropdown
									placeholder="Select Program"
									options={dropdownOptions}
									selected={truncateText(selectedProgramLabel, 34)}
									onSelect={value => {
										const selectedOption =
											dropdownOptions.find(
												item => item.value === value
											);

										setSelectedProgram(value); // ID for API
										setSelectedProgramLabel(
											selectedOption?.label || ''
										); // Label for UI
									}}
									width="100%"
									height="42px"
									variant="default"
								/> */}
								<MultiSelectDropdown
	options={dropdownOptions}
	placeholder="Select Program"
	selectedValues={selectedProgram ? [selectedProgram] : []}
	onChange={values => {
		setSelectedProgram(values[0] || '');
	}}
	width="100%"
	height="42px"
	selectedLabel="Program"
	singleSelect={true}
/>
							</div>

							<div className={styles.actions}>
								<button
									className={styles.primaryBtn}
									onClick={handleViewProgram}
								>
									View Program
								</button>
							</div>
						</div>

						{goalsLoading ? (
							<div>Loading goals...</div>
						) : goalsData.length === 0 ? (
							<div className={styles.emptyState}>
								No goals found .
							</div>
						) : (
							<LearnerTable
								data={goalsData}
								columns={[
									{
										header: 'Goal',
										key: 'goal',
									},
									{
										header: 'Progress',
										key: 'progressText',
									},
									{
										header: 'Completion Rate',
										key: 'progress',
										render: item => (
											<div
												className={
													styles.progressWrapper
												}
											>
												<div
													className={
														styles.progressTrack
													}
												>
													<div
														className={
															styles.progressFill
														}
														style={{
															width: `${item.progress}%`,
														}}
													/>
												</div>
											</div>
										),
									},
								]}
							/>
						)}
					</div>
				)}
				{activeTab === 'mentoring' && (
					<div className={styles.content}>
						{mentoringLoading ? (
							<div>Loading mentoring hours...</div>
						) : mentoringData.length === 0 ? (
							<div className={styles.emptyState}>
								No mentoring hours found.
							</div>
						) : (
							<LearnerTable
								data={mentoringData}
								columns={[
									{
										header: 'Program Name',
										key: 'programName',
									},
									{
										header: 'Hours/Minutes',
										key: 'hours',
									},
									{
    header: 'Completion Rate',
    key: 'progress',
    render: item => (
        <div className={styles.progressWrapper}>
            <div className={styles.progressTrack}>
                <div
                    className={styles.progressFill}
                    style={{
                        width: `${item.progress}%`,
                    }}
                />
            </div>
        </div>
    ),
}
								]}
							/>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default DashboardPrograms;
